import { forwardRef, type ComponentProps, type ComponentRef } from 'react';
import clsx from 'clsx';
import { Select as MuiSelect } from '@mui/material';

export type RwSelectProps = ComponentProps<typeof MuiSelect>;

// No dedicated .rw-select atom — the DS names the trigger's anatomy as composing
// `.rw-field` (the field control atom), so Select wires to that.
export const RwSelect = forwardRef<ComponentRef<typeof MuiSelect>, RwSelectProps>(function RwSelect({ className, sx, ...props }, ref) {
  return (
    <MuiSelect
      ref={ref}
      className={clsx('rw-field', className)}
      sx={[
        {
          minWidth: 0,
          maxWidth: '100%',
          width: '100%',
          flexDirection: 'row',
          '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...props}
    />
  );
});
